import { GET_TRAFFIC_CAMS, 
    GET_TRAFFIC_CAMS_WITH_GEOJSON, 
    GET_TRAFFIC_CAM_STREAM, 
    GET_TRAFFIC_CAM_DETAIL } from '../actions/trafficCamActions';
import { LOCATION_CHANGED } from '../actions/locationActions';

const geometryType = 'Point';
const featureType = 'Feature';
const geoJsonType = 'FeatureCollection';

const initialState = {
    listIsRefreshing: false,
    streamIsRefreshing: false,
    detailIsRefreshing: false
};

function transformCameraToGeoJSON ( camera, camNumber = 0 ) {
    const geoJSONResult = {
        geometry: {},
        properties: {},
        type: ''
    };

    const { cameraId, latitude, longitude } = camera;

    const coordinates = [
        longitude,
        latitude
    ];

    const geometry = {
        type: geometryType,
        coordinates: coordinates
    };

    const properties = {
        id: cameraId,
        camNumber: `${camNumber + 1}`,
        latitude: latitude,
        longitude: longitude
    };

    geoJSONResult.geometry = geometry;
    geoJSONResult.properties = properties;
    geoJSONResult.type = featureType;


    return geoJSONResult;
}

const transformCamerasDataToGeoJSON = ( cameras ) => {
    return cameras.map( (camera, index) => transformCameraToGeoJSON(camera, index));
};

export function trafficCam(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_TRAFFIC_CAMS.pending:
        {
            return {
                ...state
                , list: undefined
                , listIsRefreshing: true
            };
        }
        case GET_TRAFFIC_CAMS.fulfilled:
        {
            return {
                ...state
                , list: action.payload
                , lastError: {}
                , listIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAMS.rejected:
        {
            return {
                ...state
                , list: undefined
                , lastError: action.payload
                , listIsRefreshing: false
            };
        }

        case GET_TRAFFIC_CAMS_WITH_GEOJSON.pending:
        {
            return {
                ...state
                , list: undefined
                , trafficGeoJson: undefined
                , listIsRefreshing: true
            };
        }
        case GET_TRAFFIC_CAMS_WITH_GEOJSON.fulfilled:
        {
            const cameras = action.payload.cameras;
            const geojson = {
                features: transformCamerasDataToGeoJSON(cameras),
                type: geoJsonType
            };

            return {
                ...state
                , list: action.payload
                , trafficGeoJson: geojson
                , lastError: {}
                , listIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAMS_WITH_GEOJSON.rejected:
        {
            return {
                ...state
                , list: undefined
                , trafficGeoJson: undefined
                , lastError: action.payload
                , listIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAM_STREAM.pending:
        {
            return {
                ...state
                , stream: undefined
                , streamIsRefreshing: true
            };
        }
        case GET_TRAFFIC_CAM_STREAM.fulfilled:
        {
            return {
                ...state
                , stream: action.payload
                , lastError: {}
                , streamIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAM_STREAM.rejected:
        {
            return {
                ...state
                , stream: undefined
                , lastError: action.payload
                , streamIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAM_DETAIL.pending:
        {
            return {
                ...state
                , camera: undefined
                , detailIsRefreshing: true
            };
        }
        case GET_TRAFFIC_CAM_DETAIL.fulfilled:
        {
            return {
                ...state
                , camera: action.payload
                , lastError: {}
                , detailIsRefreshing: false
            };
        }
        case GET_TRAFFIC_CAM_DETAIL.rejected:
        {
            return {
                ...state
                , camera: undefined
                , lastError: action.payload
                , detailIsRefreshing: false
            };
        }

        default:
        {
            return state;
        }
    }
}
